import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = { class: "toast-icon" }
const _hoisted_3 = { class: "toast-message" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "toast",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              id: "toastTest",
              key: toast.id,
              class: _normalizeClass(["toast", toast.severity])
            }, [
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.iconClass(toast.severity)
                }, null, 8, ["icon"])
              ]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t(toast.message)), 1),
              _createElementVNode("div", {
                class: "toast-progress",
                style: _normalizeStyle({ animationDuration: toast.duration + 'ms' })
              }, null, 4),
              _createElementVNode("div", {
                class: "toast-delete",
                onClick: ($event: any) => (_ctx.deleteToast(toast.id))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'times-circle'] })
              ], 8, _hoisted_4)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}